var _rect, _circle, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _circle2, _circle3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle4, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGordonAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 72,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 232,
    r: 186,
    fill: "url(#halo)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166 192C166 130 206 90 256 90C306 90 346 130 346 192V264C346 333 307 383 256 383C205 383 166 333 166 264V192Z",
    fill: "#FFD8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 214C146 208 133 216 129 231C124 246 133 262 147 266C161 270 174 260 177 246C180 234 172 220 160 214Z",
    fill: "#F1BA9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352 214C366 208 379 216 383 231C388 246 379 262 365 266C351 270 338 260 335 246C332 234 340 220 352 214Z",
    fill: "#F1BA9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203 222C214 215 229 214 240 219",
    stroke: "#563931",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272 219C283 214 298 215 309 222",
    stroke: "#563931",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223,
    cy: 245,
    rx: 10,
    ry: 13,
    fill: "#2B1D18"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289,
    cy: 245,
    rx: 10,
    ry: 13,
    fill: "#2B1D18"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 240,
    r: 3,
    fill: "#FFF8F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 240,
    r: 3,
    fill: "#FFF8F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256 252C250 267 247 282 249 295C253 298 260 298 264 295",
    stroke: "#E3A486",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232 320C248 329 264 329 280 320",
    stroke: "#A95A50",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212 290C225 301 241 307 256 307C271 307 287 301 300 290",
    stroke: "#8E4D42",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179 194C184 132 216 102 256 102C296 102 328 132 333 194C312 175 286 166 256 166C226 166 200 175 179 194Z",
    fill: "#74483C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M205 173C216 163 231 158 256 158C281 158 296 163 307 173",
    stroke: "#8B594A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155 430C166 372 207 332 256 332C305 332 346 372 357 430L360 438H152L155 430Z",
    fill: "#F8F5EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202 354C216 371 234 381 256 382C278 381 296 371 310 354L330 376L311 438H201L182 376L202 354Z",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185 391H327",
    stroke: "#D8D2C9",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204 412H308",
    stroke: "#E8E2D7",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257 334C225 334 198 313 189 284C200 290 214 292 229 292H285C300 292 314 290 325 284C316 313 289 334 257 334Z",
    fill: "#F6C5AA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171 141C162 122 166 101 181 88C189 71 205 60 224 60C239 46 260 40 282 43C303 46 321 59 331 77C349 82 363 95 370 113C387 125 396 145 392 167C388 189 373 206 353 213C340 187 323 168 302 158C287 151 271 148 256 148C225 148 195 161 171 192V141Z",
    fill: "#FFFFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191 125C187 106 193 92 208 84",
    stroke: "#DDD8CF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M320 118C325 100 320 86 307 77",
    stroke: "#DDD8CF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205 79C220 68 241 64 256 64C271 64 291 68 307 79",
    stroke: "#E6E1D8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M166 126C149 114 144 92 154 73C164 54 186 47 205 56",
    stroke: "#FFF6E8",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M345 126C362 114 367 92 357 73C347 54 325 47 306 56",
    stroke: "#FFF6E8",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 120,
    r: 32,
    fill: "#FFB43C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M382 108H403",
    stroke: "#6B3C10",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380 120H405",
    stroke: "#6B3C10",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M384 132H401",
    stroke: "#6B3C10",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M374 146C381 152 389 155 398 155C407 155 415 152 422 146",
    stroke: "#6B3C10",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 52,
    y1: 46,
    x2: 460,
    y2: 468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7A2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A3025"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 216) rotate(90) scale(232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0D6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGordonAvatar);
export default __webpack_public_path__ + "static/media/gordon-avatar.14db290ac28102d3b72162dd917f7485.svg";
export { ForwardRef as ReactComponent };